var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_1111)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.74023,
    cy: 6.45575,
    r: 1.5,
    fill: "#E87663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4803 6.45572C10.4803 9.07363 8.35806 11.1959 5.74015 11.1959C3.12224 11.1959 1 9.07363 1 6.45572C1 3.83781 3.12224 1.71558 5.74015 1.71558C8.35806 1.71558 10.4803 3.83781 10.4803 6.45572Z",
    stroke: "#E87663",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5251 4.96332C13.0517 4.96332 12.668 5.34707 12.668 5.82046C12.668 6.29385 13.0517 6.6776 13.5251 6.6776H17.9625C18.9092 6.6776 19.6767 7.44512 19.6767 8.39189V17.7574H4.27388V14.0053C4.27388 13.5319 3.89013 13.1481 3.41674 13.1481C2.94335 13.1481 2.5596 13.5319 2.5596 14.0053V17.8298H2H0V19.8298V20.7781C0 21.595 0.421425 22.3785 1.17156 22.9562C1.9217 23.5339 2.93911 23.8584 3.99997 23.8584H19.9999C21.0607 23.8584 22.0781 23.5339 22.8283 22.9562C23.5784 22.3785 23.9998 21.595 23.9998 20.7781V19.8298V17.8298H21.9998H21.391V8.39189C21.391 6.49834 19.856 4.96332 17.9625 4.96332H13.5251ZM2 20.7781V19.8298H21.9998V20.7781C21.9998 20.8708 21.9548 21.1045 21.608 21.3716C21.2495 21.6477 20.6753 21.8584 19.9999 21.8584H3.99997C3.32455 21.8584 2.75029 21.6477 2.39185 21.3716C2.04499 21.1045 2 20.8708 2 20.7781Z",
    fill: "#E87663"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_1111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.715576)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.45e5d23005888f1ac55befa3c0c94e12.svg";
export { ForwardRef as ReactComponent };